import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '@core/services';
import { PermissionsList } from '@shared/enum/Permissions/PermissionList';
import { inject } from '@angular/core';

type TPermission = keyof typeof PermissionsList;

export const permissionGuard = (
  permissions: TPermission | TPermission[]
): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const permissionService = inject(PermissionsService);
    const permissionsList = Array.isArray(permissions)
      ? permissions
      : [permissions];
    if (permissionService.hasAnyPermission(permissionsList)) {
      return true;
    }
    router.navigate(['/403']);
    return false;
  };
};
